var building_types ={
  building_types: {
    highrise: {
    id: "1",
    txt_id: "highrise",
    name: "Highrise",
    description: "Building with 7 stories and up"
    },
    lowrise: {
    id: "3",
    txt_id: "lowrise",
    name: "Low rise",
    description: "Building with 6 stories or less"
    },
    house: {
    id: "4",
    txt_id: "house",
    name: "House",
    description: "House"
    }
  }
}

module.exports = building_types
